import { VisitMedicalInformation } from '@dreryk/egabinet-visit-frontend-api';

import { AddCircleIcon, IconSize, IconWrapper, Table } from '@dreryk/react-components';

import { AddMedicalInformationLink } from './AddMedicalInformationLink';
import {
   useMedicalInformationDataConfiguration,
   useMedicalInformationTableColumns,
} from './MedicalInformationTable.hooks';
import { StyledMedicalInformationTable } from './MedicalInformationTable.styled';
import { MedicalInformationTableEmptyStatePlaceholder } from './MedicalInformationTableEmptyStatePlaceholder';

type MedicalInformationTableProps = {
   readonly patientId: number;
   readonly visitId: number;
};

export const MedicalInformationTable = (props: MedicalInformationTableProps): JSX.Element => {
   const columns = useMedicalInformationTableColumns();
   const dataConfiguration = useMedicalInformationDataConfiguration(props.visitId);

   return (
      <StyledMedicalInformationTable direction={'column'}>
         <Table<VisitMedicalInformation>
            columns={columns}
            dataConfiguration={dataConfiguration}
            testId={'medicalInformationTable'}
            keyExtractor={'medicalInformationId'}
            placeholder={
               <MedicalInformationTableEmptyStatePlaceholder patientId={props.patientId} visitId={props.visitId} />
            }
            compact
            bottomElement={
               <AddMedicalInformationLink
                  patientId={props.patientId}
                  visitId={props.visitId}
                  icon={
                     <IconWrapper testId={'addMedicalInformationLinkIcon'} size={IconSize.SMALL}>
                        <AddCircleIcon />
                     </IconWrapper>
                  }
               />
            }
         />
      </StyledMedicalInformationTable>
   );
};
